/**
 * 상품 테마 선택을 다루는 화면(호스트 상품 수정 / 어드민 상품 수정)이 공유하는 규칙.
 * 두 화면이 같은 판정을 따로 들고 있으면 한쪽만 고쳐졌을 때 "저장했는데 사라지는" 차이가 생긴다.
 */

/**
 * 상품 본문은 저장됐는데 테마 매핑만 실패했을 때 서버가 응답 본문에 실어 보내는 식별자.
 * NestJS `PRODUCT_THEME_UPDATE_FAILED`(product.dto.ts)와 같은 값이어야 한다.
 */
export const PRODUCT_THEME_UPDATE_FAILED = 'PRODUCT_THEME_UPDATE_FAILED';

/** 불러온 시점과 견줘 테마 선택이 바뀌었는지. 순서는 무시하고 구성만 본다. */
export function hasThemeSelectionChanged(current: number[], loaded: number[]): boolean {
  if (current.length !== loaded.length) return true;
  const base = new Set(loaded);
  return current.some((id) => !base.has(id));
}

/**
 * 상품 저장 실패가 "테마만 실패"인지 가려내고, 맞으면 호스트에게 보여줄 사유를 돌려준다.
 *
 * 테마 반영은 상품 트랜잭션이 커밋된 뒤에 돌기 때문에 이 실패는 본문 저장까지 실패한 것이 아니다.
 * 구분하지 않으면 "작성하신 내용이 저장되지 않을 수 있으니 백업하세요" 안내가 뜨고, 실제로는 저장된
 * 내용을 호스트가 다시 입력하게 된다.
 */
export function toThemeUpdateErrorMessage(error: unknown): string | null {
  const body = (error as { error?: { code?: string; message?: string } } | null)?.error;
  if (!body || body.code !== PRODUCT_THEME_UPDATE_FAILED) return null;
  return typeof body.message === 'string' && body.message ? body.message : '테마 저장에 실패했습니다.';
}
